// extracted by mini-css-extract-plugin
module.exports = {"recycleProductRegistration":"RecycleProductRegistration_recycleProductRegistration__3t51w"};